import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
const painPoints = [{
  emoji: '📱',
  bold: 'Ves mesas de resina en Instagram',
  text: <>
        y pensás <em className="text-gray-500" data-id="element-121">"yo quiero hacer eso"</em> — pero{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-122">
          no sabés por dónde empezar
        </span>
        .
      </>
}, {
  emoji: '🫧',
  bold: 'Compraste resina, seguiste un tutorial',
  text: <>
        y quedó{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-123">llena de burbujas</span>.{' '}
        <span className="underline-red" data-id="element-124">
          Tiraste miles de pesos sin saber qué hiciste mal.
        </span>
      </>
}, {
  emoji: '🌍',
  bold: 'Buscás tutoriales y todos son de afuera.',
  text: <>
        Los materiales{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-125">no existen en Uruguay</span>{' '}
        y los precios no tienen nada que ver.
      </>
}, {
  emoji: '🪞',
  bold: 'Hacés la mesa y queda bien,',
  text: <>
        pero no tiene ese{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-126">brillo espejo</span> que ves
        en las fotos. Y sin ese brillo no podés cobrar lo que vale.
      </>
}, {
  emoji: '💸',
  bold: 'Vendiste una mesa y después te diste cuenta',
  text: <>
        de que trabajaste horas para{' '}
        <span className="font-bold text-[#DC2626]" data-id="element-127">ganar casi nada</span> porque
        no sabías cómo calcular el precio.
      </>
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function PainPointsSection() {
  return <section className="py-[56px] md:py-[80px] px-5 bg-[#F9FAFB] relative" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-130">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-6 flex items-center justify-center gap-4" data-id="element-131">
            <AlertTriangleIcon className="w-8 h-8 text-[#DC2626]" data-id="element-132" />
            ¿TE PASA ESTO?
          </h2>
          <div className="w-24 h-1 bg-[#DC2626]/30 mx-auto mt-6" data-id="element-133"></div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-subtitle text-gray-600 text-center mb-12 italic leading-relaxed" data-id="element-134">
          Si te identificás con alguna de estas situaciones, esta guía fue
          creada para vos...
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-[16px]" data-id="element-135">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="card-light border-l-[5px] border-l-[#DC2626] px-[24px] py-[22px] hover:border-l-[#EF4444] hover:translate-x-[4px] transition-all duration-300 flex gap-4 items-start" data-id="element-136">
              <span className="text-3xl shrink-0 mt-1" data-id="element-137">{point.emoji}</span>
              <p className="text-body-main text-gray-700 leading-relaxed" data-id="element-138">
                <strong className="font-bold text-[#B91C1C] block mb-1" data-id="element-139">
                  {point.bold}
                </strong>
                {point.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}